/**
 * Returns a shorter path if the requested document is repeated in the path
 */
export function shortenPath(path: string | undefined): string | undefined {
  if (!path) {
    return path;
  }

  const suffixMatch = path.match(/[?#].*$/);
  const suffix = suffixMatch?.[0] ?? '';
  const pathname = suffix ? path.slice(0, -suffix.length) : path;
  const parts = pathname.split('/');
  const entityId = parts[parts.length - 1];
  const entityType = parts[parts.length - 2];

  if (!entityType || !entityId) {
    return path;
  }

  for (let i = 0; i < parts.length - 2; i++) {
    if (parts[i] === entityType && parts[i + 1] === entityId) {
      return parts.slice(0, i + 2).join('/') + suffix;
    }
  }

  return path;
}
